// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
import { isNumber } from '../../../utils';
import SVGInline from "react-svg-inline"

// inner imports
import { MUSICIAN } from "../../../consts";

// css imports
import './main-styles.css';
import './contactbandfinder.css';

// svg imports
import phoneSVG from '../../inlineSVGs/phoneSVG';
import mailSVG from '../../inlineSVGs/mailSVG';
import fbSVG from '../../inlineSVGs/fbLinkSVG';

const ContactBandFinder = ({ formType, phone, email, fblink, updateValue, desc, userShouldEnter }) => {
    const validatePhone = (event) => {
        if (!isNumber(event.target.value) && event.target.value.length > 0) return;
        if (event.target.value.length > 15) return;
        updateValue(event);
    };

    return (
        <div className="contact-band-finder-mobile-wrapper rtl">
            <div className={"title " + formType}>
                פרטים ליצירת קשר
            </div>
            <div className="contact-band-finder-wrapper input-wrapper">
                <div className="left-input-wrapper rtl">
                <textarea
                    name="desc"
                    id="contact-band-finder-desc"
                    placeholder="עוד משהו?"
                    cols="2"
                    value={desc}
                    rows="3"
                    onChange={updateValue}
                >
                </textarea>
                </div>

                <div className="right-input-wrapper rtl">
                    <div className="sub-title">איך ליצור קשר?</div>
                    <div className="input-wrapper">
                        <SVGInline className={`phone-icon ${formType === MUSICIAN ? 'musician' : 'band'}`} svg={phoneSVG}/>

                        <input
                            className={`phone-input ${formType === MUSICIAN ? 'musician' : 'band'} ${(userShouldEnter && userShouldEnter.indexOf('phone') > -1 ? 'required' : '')}`}
                            type="tel"
                            min="0"
                            name="phone"
                            onChange={(event) => validatePhone(event)}
                            value={phone}
                            placeholder={'טלפון'}
                        />
                    </div>

                    <div className="input-wrapper">
                        <SVGInline className={`email-icon ${formType === MUSICIAN ? 'musician' : 'band'}`} svg={mailSVG}/>

                        <input
                            type="text"
                            className={`email-input ${formType === MUSICIAN ? 'musician' : 'band'} ${(userShouldEnter && userShouldEnter.indexOf('email') > -1 ? 'required' : '')}`}
                            name="email"
                            onChange={updateValue}
                            value={email}
                            placeholder={'מייל'}
                        />
                    </div>

                    <div className="input-wrapper">
                        <SVGInline className={`fblink-icon ${formType === MUSICIAN ? 'musician' : 'band'}`} svg={fbSVG}/>

                        <input
                            type="text"
                            className={`fblink-input ${formType === MUSICIAN ? 'musician' : 'band'} ${(userShouldEnter && userShouldEnter.indexOf('fblink') > -1 ? 'required' : '')}`}
                            name="fblink"
                            onChange={updateValue}
                            value={fblink}
                            placeholder={'לינק לפייסבוק'}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};

ContactBandFinder.propTypes = {
    formType: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    fblink: PropTypes.string,
    desc: PropTypes.string,
    updateValue: PropTypes.func.isRequired,
    userShouldEnter: PropTypes.array
};

export default ContactBandFinder;



// WEBPACK FOOTER //
// ./src/Components/Elements/Inputs/ContactBandFinder.js